import { Component, Show, createSignal } from "solid-js"
import type { ClockAnnotation } from "../types"

interface MobileMessageBannerProps {
    annotation: ClockAnnotation | null
    onDismiss: () => void
}

const MobileMessageBanner: Component<MobileMessageBannerProps> = (props) => {
    const [isDismissed, setIsDismissed] = createSignal(false)
    const [touchStartY, setTouchStartY] = createSignal(0)
    const [translateY, setTranslateY] = createSignal(0)
    let autoHideTimer: number | undefined

    // Reset dismissed state when new annotation appears
    let lastAnnotationId = ""
    const shouldShow = () => {
        if (!props.annotation) return false

        // New annotation, reset dismissed state
        if (props.annotation.id !== lastAnnotationId) {
            lastAnnotationId = props.annotation.id
            setIsDismissed(false)
            setTranslateY(0)

            // Auto-hide after 21 seconds (same as desktop)
            if (autoHideTimer) clearTimeout(autoHideTimer)
            autoHideTimer = window.setTimeout(() => {
                setIsDismissed(true)
                props.onDismiss()
            }, 21000)
        }

        return !isDismissed()
    }

    const handleTouchStart = (e: TouchEvent) => {
        setTouchStartY(e.touches[0].clientY)
    }

    const handleTouchMove = (e: TouchEvent) => {
        const currentY = e.touches[0].clientY
        const deltaY = currentY - touchStartY()

        // Only allow upward swipe (negative deltaY)
        if (deltaY < 0) {
            setTranslateY(deltaY)
        }
    }

    const handleTouchEnd = () => {
        // If swiped up more than 50px, dismiss
        if (translateY() < -50) {
            if (autoHideTimer) clearTimeout(autoHideTimer)
            setIsDismissed(true)
            props.onDismiss()
        }
        setTranslateY(0)
    }

    return (
        <Show when={shouldShow()}>
            <div
                class="fixed top-14 right-0 left-0 z-30 bg-gray-900/95 text-white shadow-lg transition-transform duration-200 md:hidden"
                style={{ transform: `translateY(${translateY()}px)` }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <div class="px-4 py-4">
                    <div class="text-sm leading-tight whitespace-pre-line">{props.annotation?.text}</div>
                </div>

                {/* Swipe indicator */}
                <div class="absolute bottom-0.5 left-1/2 -translate-x-1/2">
                    <div class="h-0.5 w-6 rounded-full bg-white/30" />
                </div>
            </div>
        </Show>
    )
}
export default MobileMessageBanner
